import { useContext} from "react";
import CustomSpinner from "../components/CustomSpinner";
import LoginComponent from "../components/LoginComponent";
import UserContext from "../context/UserContext";

export default function Dashboard() {

    const { user, loading } = useContext(UserContext)


    return (
        <>
            {user === null ?
                <div className="app-shell banner-1">
                    <div className="mx-auto flex max-w-6xl justify-center">
                        <LoginComponent />
                    </div>
                </div>
                :
                <>
                    {
                        loading && (<CustomSpinner />)
                    }
                    <div className="app-shell banner-1">
                    </div>

                </>
            }
        </>

    );
}
